import React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { usePageTitle } from '../../config';
import VendorDealDetails from './VendorDealDetails';
import VendorDeals from './VendorDeals';

export function DiscountRoute() {
  const { updatePageTitle } = usePageTitle();
  updatePageTitle('Vendor Deals - Xvantage GDS');

  return (
    <Routes>
      <Route element={<Navigate replace to="deals-list" />} path="" />
      <Route element={<VendorDeals />} path="deals-list" />
      <Route element={<VendorDealDetails />} path="deal-details" />
    </Routes>
  );
}
